import { Component, OnInit } from '@angular/core';
import {StripHtmlPipe} from '../../stripHtml';
import { CommonService } from '../../shared/services/common-service';

@Component({
  selector: 'app-wijaya-news',
  templateUrl: './wijaya-news.component.html',
  styleUrls: ['./wijaya-news.component.css']
})
export class WijayaNewsComponent implements OnInit {

  public wijayanews;

  constructor(
private commonService: CommonService,private striphtml :StripHtmlPipe,
  ) { }

  ngOnInit() {
    this.getWijayaNews();
  }

  getWijayaNews(){
    // this.commonService.getwijayanews().then((response: any) => {
    //  this.wijayanews=response;
    // })

  }

  public openNewTab(url:string) {
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/wijaya-news/wijaya-news.component.ts